// HOME
export const DEROM_ENABLED = 'Derom.Enabled';
export const CA_ENABLED = 'CA.Chatbot.Enabled';

// HSG
export const KAKI_ENABLED = 'KAKI.Enabled';
export const KAKI_INTERVAL = 'KAKI.RefreshInterval';
export const NEHR_ENROLMENT_IS_AR = 'HealthRecords.OptOut.IsAR';

// ED
export const ED_INSTITUTION_LIST = 'ED.InstitutionList';

// PAYMENT SETTINGS
export const CREDIT_ENABLED = 'Credit.Onemid.Enabled';
export const DEBIT_ENABLED = 'Debit.Onemid.Enabled';
export const AMEX_ENABLED = 'Amex.Onemid.Enabled';
export const MOBILE_PAYMENT_CALLBACK_REDIRECT_URL = 'Mobile.PaymentService.2C2P.FrontendCallbackUrl';
export const USE_ENETS_PAYMENT = 'BillsAndPayment.UseENetsPayment';

export const APPOINTMENT_MAINTENANCE_SOURCEAPP = 'Appointment.ImportantNote.Maintenance.SourceApp';

export const VideoConsultSettings = {
  ValidServiceTypeDetails: 'Appointment.VC.ValidServiceTypeDetails',
  NuhsLearnTeleconsultLink: 'Appointment.VC.NuhsLearnTeleconsultLink',
  QueueAutoRefreshIntervalInMinutes: 'Appointment.VC.QueueAutoRefreshIntervalInMinutes',
} as const;

export const DoctorConsultApptSettings = {
  AvailabilityFrom: 'Appointment.DoctorConsult.Availability.From',
  AvailabilityTo: 'Appointment.DoctorConsult.Availability.To',
  // Kill switch for the whole traffic-light doctor consultation flow. Overrides the availability
  // window: when off, nothing shows even inside 10pm-12am.
  TrafficLightEnabled: 'Appointment.TrafficLightDoctorConsult.IsEnabled',
} as const;

export const DentalApptDepositSettings = {
  ForfeitDays: 'Appointment.DentalDeposit.ForfeitDays',
  ServiceTypes: 'Appointment.DentalServiceTypeId',
} as const;

export const ScreeningEissDateConfiguration = 'Appointments.Screening.EissDateConfiguration';

// WOGAA transactional tracking ID (US #661262). Per the WOGAA team, there is only one tracking
// ID for the whole app (not one per flow) — all flow keys below intentionally resolve to the
// same System Settings category. Kept as a per-flow map (rather than a single constant) so each
// route's `settingKey` stays self-describing and callers are unaffected if WOGAA ever splits
// tracking IDs per flow again.
const WOGAA_TRACKING_ID_CATEGORY = 'WOGAA.TrackingId';
export const WogaaTrackingSettings = {
  AppointmentRequest: WOGAA_TRACKING_ID_CATEGORY,
  BookNext: WOGAA_TRACKING_ID_CATEGORY,
  BreastCancerScreening: WOGAA_TRACKING_ID_CATEGORY,
  CervicalCancerScreening: WOGAA_TRACKING_ID_CATEGORY,
  MakeNewAppointment: WOGAA_TRACKING_ID_CATEGORY,
  Reschedule: WOGAA_TRACKING_ID_CATEGORY,
} as const;
